import { Aplicacion } from "./aplicacion";

/* tslint:disable:variable-name */
export class AplicacionVersion {
  id: number;
  version: string;
  descripcion: string;
  activo: boolean;
  aplicacion: Aplicacion;





  constructor(id?: number, version?: string, descripcion?: string, activo?: boolean, aplicacion?: Aplicacion) {
    this.id = id ?? null;
    this.version = version ?? '';
    this.descripcion = descripcion ??'';
    this.activo = activo?? true ;
    this.aplicacion = aplicacion ?? new Aplicacion();
  }
}
